// Italiano — testi legali e assistenza.
export default (C) => ({
  ui: {
    header: "LEGALE & ASSISTENZA",
    back: "INDIETRO",
    nav: "Documenti legali",
    onThisPage: "IN QUESTA PAGINA",
    lastUpdated: "ULTIMO AGGIORNAMENTO",
    effective: "29 ottobre 2026",
    companyDetails: "DATI AZIENDALI",
    cd: { company: "Società", nipt: "NIPT / Codice fiscale", office: "Sede legale e punto di assistenza", email: "E-mail", phone: "Telefono" },
  },

  privacy: {
    kicker: "LEGALE · PRIVACY",
    title: "Informativa sulla privacy",
    intro: "Come Eagle Inc tratta i tuoi dati personali — sui nostri siti web, nei nostri servizi e quando ci paghi con carta, Apple Pay, Google Pay, link di pagamento o codice QR.",
    sections: [
      {
        id: "who-we-are",
        title: "Chi siamo",
        body: [
          `La presente informativa spiega come ${C.legalName} ("Eagle Inc", "noi") raccoglie, utilizza e protegge i dati personali quando visiti uno dei nostri siti web, ci contatti, ricevi una fattura o ci paghi con carta, Apple Pay, Google Pay, link di pagamento o codice QR.`,
          "Si applica a tutti i siti web del gruppo Eagle Inc, tra cui eagle-inc.net, eagle-inc.al, eagle-inc.eu, eagle-eyes.al, eagle-commerce.al, digital-services.al, socialdeal.al, bookitnow.al e incontact.al, e ai servizi offerti con i marchi Eagle Eyes (Real Estate, IT Management, Digital Services) ed Eagle Commerce.",
          {
            kv: [
              ["Titolare del trattamento", C.legalName],
              ["Denominazioni commerciali", C.tradeNames],
              ["NIPT / Codice fiscale", C.nuis],
              ["Indirizzo della sede legale", C.address],
              ["Contatto privacy", C.supportEmail],
              ["Telefono", C.supportPhone],
            ],
          },
        ],
      },
      {
        id: "legal-framework",
        title: "Quadro normativo",
        body: [
          "Trattiamo i dati personali in conformità alla Legge albanese n. 124/2024 \"Sulla protezione dei dati personali\". Se ti trovi nell'Unione europea o nello Spazio economico europeo e al nostro trattamento si applica il Regolamento generale sulla protezione dei dati (GDPR, Regolamento (UE) 2016/679), rispettiamo anche il GDPR.",
          "L'autorità di controllo in Albania è il Commissario per il diritto all'informazione e la protezione dei dati personali (Komisioneri për të Drejtën e Informimit dhe Mbrojtjen e të Dhënave Personale), https://idp.al.",
        ],
      },
      {
        id: "data-we-collect",
        title: "Dati personali che raccogliamo",
        body: [
          "Raccogliamo solo i dati necessari per le finalità descritte di seguito:",
          {
            list: [
              "Dati identificativi e di contatto — nome, ragione sociale, indirizzo e-mail, numero di telefono e indirizzo postale o di fatturazione, forniti da te tramite i nostri moduli di contatto e assistenza, via e-mail, telefono o WhatsApp, oppure quando prepariamo un preventivo, un contratto o una fattura.",
              "Dati contrattuali e di fatturazione — i servizi ordinati, preventivi, contratti, fatture, numeri di fattura, importi, valuta, dati IVA e corrispondenza relativa all'incarico.",
              "Dati delle transazioni di pagamento — stato del pagamento, data, importo, valuta, tipo di metodo di pagamento (ad es. Visa, Mastercard, Apple Pay, Google Pay), un riferimento di autorizzazione o di transazione e, se fornito dalla banca, un numero di carta mascherato (ad es. le ultime quattro cifre). Non riceviamo né conserviamo mai numeri di carta completi, date di scadenza o codici CVV/CVC.",
              "Dati di assistenza — il contenuto delle tue richieste di assistenza e di rimborso e qualsiasi informazione che scegli di condividere con noi quando ti aiutiamo.",
              "Dati tecnici — indirizzo IP, tipo di browser, informazioni sul dispositivo e log delle richieste che la nostra infrastruttura di hosting registra automaticamente per la sicurezza e per erogare il sito.",
            ],
          },
          "Non raccogliamo consapevolmente categorie particolari di dati personali e ti chiediamo di non inviarci tali dati.",
        ],
      },
      {
        id: "card-payments",
        title: "Pagamenti con carta, Apple Pay e Google Pay",
        body: [
          "I pagamenti con carta sono elaborati dalla nostra banca acquirer, Raiffeisen Bank Sh.A. (Albania), tramite il suo servizio di e-commerce RaiAccept. Quando paghi tramite un link di pagamento o un codice QR RaiAccept, inserisci i dati della carta — o autorizzi Apple Pay o Google Pay — sulla pagina di pagamento sicura della banca, non sul nostro sito.",
          {
            list: [
              "I dati della tua carta sono trasmessi in forma crittografata (TLS) direttamente alla banca e alla sua infrastruttura di pagamento conforme a PCI DSS. Eagle Inc non vede, non tratta e non conserva il numero completo della tua carta né il codice di sicurezza.",
              "I pagamenti possono essere verificati dall'emittente della carta con 3-D Secure (ad es. Visa Secure, Mastercard Identity Check).",
              "Se usi Apple Pay o Google Pay, Apple o Google trattano i tuoi dati secondo le proprie informative sulla privacy; la banca riceve un numero di carta tokenizzato, non il tuo numero di carta reale.",
              "Raiffeisen Bank, i circuiti di pagamento (Visa, Mastercard) e l'emittente della tua carta agiscono come titolari autonomi per i dati che trattano per eseguire, proteggere e regolare il pagamento e per prevenire le frodi.",
              "Dalla banca riceviamo solo le informazioni necessarie per abbinare il pagamento alla tua fattura e gestire rimborsi e contestazioni (vedi \"Dati personali che raccogliamo\").",
            ],
          },
        ],
      },
      {
        id: "purposes",
        title: "Perché usiamo i tuoi dati e base giuridica",
        body: [
          {
            kv: [
              ["Rispondere alle tue richieste", "Misure precontrattuali adottate su tua richiesta; nostro legittimo interesse a rispondere ai messaggi."],
              ["Preventivi, contratti ed erogazione dei servizi", "Esecuzione di un contratto con te."],
              ["Fatturazione e incasso dei pagamenti", "Esecuzione di un contratto; obbligo di legge (normativa contabile e fiscale)."],
              ["Rimborsi, chargeback e contestazioni di pagamento", "Esecuzione di un contratto; obbligo di legge; legittimo interesse a difendere i propri diritti in sede giudiziaria."],
              ["Assistenza clienti", "Esecuzione di un contratto; legittimo interesse a fornire un buon servizio."],
              ["Prevenzione delle frodi e sicurezza del sito", "Legittimo interesse a proteggere i nostri clienti, la nostra attività e i nostri sistemi; obbligo di legge ove applicabile."],
              ["Registri contabili, fiscali e normativi", "Obbligo di legge."],
              ["Memorizzare la lingua scelta", "Legittimo interesse a un sito funzionante (memorizzata solo nel tuo browser)."],
            ],
          },
          "Non vendiamo dati personali, non li utilizziamo per decisioni automatizzate che producono effetti giuridici o effetti analogamente significativi su di te e inviamo messaggi di marketing solo se li hai richiesti. Puoi annullare l'iscrizione in qualsiasi momento.",
        ],
      },
      {
        id: "recipients",
        title: "Con chi condividiamo i dati",
        body: [
          "Condividiamo i dati personali solo se necessario, con:",
          {
            list: [
              "Raiffeisen Bank Sh.A. (Albania) e i circuiti e le reti di pagamento coinvolti nell'elaborazione del tuo pagamento, nonché Apple o Google se usi il loro wallet.",
              "Microsoft (hosting Microsoft Azure e servizi di posta e produttività Microsoft 365) — in qualità di nostro responsabile del trattamento.",
              "MongoDB Inc. (hosting di database MongoDB Atlas per i moduli inviati dal sito) — in qualità di nostro responsabile del trattamento.",
              "GitHub (hosting del codice sorgente e pipeline di build; lì non sono conservati dati dei clienti).",
              "I nostri commercialisti, revisori e consulenti legali, vincolati al segreto professionale.",
              "Autorità pubbliche, tribunali e forze dell'ordine quando siamo obbligati per legge.",
            ],
          },
          "Ogni responsabile del trattamento è vincolato da un accordo scritto e può utilizzare i tuoi dati solo secondo le nostre istruzioni.",
        ],
      },
      {
        id: "transfers",
        title: "Trasferimenti internazionali",
        body: [
          "Alcuni nostri fornitori (come Microsoft e MongoDB) possono trattare dati nell'Unione europea o in altri paesi al di fuori dell'Albania. Quando i dati sono trasferiti verso un paese che non offre un livello di protezione adeguato, ci basiamo su garanzie adeguate previste dalla Legge n. 124/2024 e, ove applicabile, dal GDPR — come le clausole contrattuali standard — e sugli impegni di sicurezza dei fornitori stessi.",
        ],
      },
      {
        id: "retention",
        title: "Per quanto tempo conserviamo i dati",
        body: [
          {
            list: [
              "Richieste e richieste di assistenza che non portano a un contratto: fino a 24 mesi dall'ultimo contatto.",
              "Contratti, fatture, registrazioni di pagamento e contabili: per il periodo previsto dalla normativa contabile e fiscale albanese.",
              "Dati necessari per una contestazione, un rimborso o un chargeback: fino alla completa risoluzione della questione e alla scadenza dell'eventuale termine di prescrizione.",
              "Dati di log tecnici: di norma non oltre 90 giorni, salvo che servano per indagare su un incidente di sicurezza.",
            ],
          },
          "Trascorsi questi periodi, i dati vengono cancellati o resi anonimi.",
        ],
      },
      {
        id: "cookies",
        title: "Cookie e archiviazione locale",
        body: [
          "I nostri siti non utilizzano cookie pubblicitari o di tracciamento. Memorizziamo un solo elemento nell'archivio locale del tuo browser — la lingua di visualizzazione scelta — affinché il sito la ricordi. Questo elemento non lascia mai il tuo dispositivo e puoi eliminarlo in qualsiasi momento dalle impostazioni del browser.",
          "Per visualizzare i nostri caratteri, il tuo browser carica font da Google Fonts e Fontshare, che ricevono il tuo indirizzo IP nell'ambito di tale richiesta tecnica. La pagina di pagamento RaiAccept, gestita dalla banca, può utilizzare propri cookie strettamente necessari per la sicurezza e la prevenzione delle frodi.",
        ],
      },
      {
        id: "security",
        title: "Come proteggiamo i tuoi dati",
        body: [
          "Tutti i nostri siti sono serviti esclusivamente tramite HTTPS. I dati sono conservati presso fornitori cloud affidabili, l'accesso è limitato a persone autorizzate con autenticazione a più fattori e applichiamo il principio del privilegio minimo. I dati delle carte non raggiungono mai i nostri sistemi.",
          "In caso di violazione dei dati personali che possa comportare un rischio per i tuoi diritti, la notificheremo al Commissario entro 72 ore e ti informeremo senza ingiustificato ritardo se il rischio è elevato, come previsto dalla legge.",
        ],
      },
      {
        id: "your-rights",
        title: "I tuoi diritti",
        body: [
          "Alle condizioni previste dalla legge, hai il diritto di:",
          {
            list: [
              "essere informato e ottenere l'accesso ai dati personali che conserviamo su di te;",
              "ottenere la rettifica dei dati inesatti e l'integrazione di quelli incompleti;",
              "ottenere la cancellazione dei tuoi dati (\"diritto all'oblio\");",
              "ottenere la limitazione del trattamento dei tuoi dati;",
              "ricevere i tuoi dati in un formato strutturato e leggibile da dispositivo automatico (portabilità dei dati);",
              "opporti al trattamento basato sui nostri legittimi interessi e, in qualsiasi momento, al marketing diretto;",
              "revocare il consenso prestato, senza pregiudicare il trattamento precedente.",
            ],
          },
          `Per esercitare i tuoi diritti, scrivi a ${C.supportEmail} oppure a ${C.legalName}, ${C.address}. Potremmo chiederti di verificare la tua identità e risponderemo entro i termini di legge (di norma entro un mese).`,
          "Hai inoltre il diritto di proporre reclamo al Commissario per il diritto all'informazione e la protezione dei dati personali (https://idp.al) oppure, nell'UE/SEE, all'autorità di protezione dei dati del tuo paese di residenza.",
        ],
      },
      {
        id: "children",
        title: "Minori",
        body: ["I nostri servizi sono destinati ad aziende e adulti. Non raccogliamo consapevolmente dati personali di minori di 16 anni."],
      },
      {
        id: "changes",
        title: "Modifiche alla presente informativa",
        body: [
          "Possiamo aggiornare questa informativa di tanto in tanto. La versione in vigore è sempre disponibile su /privacy, con la data dell'ultimo aggiornamento indicata in cima alla pagina. Le modifiche sostanziali saranno comunicate via e-mail ai clienti esistenti.",
        ],
      },
      {
        id: "contact",
        title: "Contatti",
        body: [
          { kv: [["Società", C.legalName], ["Indirizzo", C.address], ["E-mail", C.supportEmail], ["Telefono", C.supportPhone], ["Assistenza", "/support"]] },
        ],
      },
    ],
  },

  terms: {
    kicker: "LEGALE · TERMINI D'USO",
    title: "Termini d'uso",
    intro: "Le condizioni che si applicano ai nostri siti web, ai nostri servizi e ai pagamenti effettuati a Eagle Inc con carta, Apple Pay, Google Pay, link di pagamento o codice QR — compresa la nostra politica di annullamento e rimborso.",
    sections: [
      {
        id: "merchant",
        title: "Informazioni sull'esercente",
        body: [
          "I presenti Termini d'uso disciplinano l'utilizzo dei siti web del gruppo Eagle Inc e l'acquisto e il pagamento dei nostri servizi. L'esercente e venditore per tutti i pagamenti è:",
          {
            kv: [
              ["Esercente", C.legalName],
              ["Denominazioni commerciali", C.tradeNames],
              ["NIPT / Codice fiscale", C.nuis],
              ["Indirizzo della sede legale", C.address],
              ["Paese", "Albania"],
              ["Assistenza clienti", `${C.supportEmail} · ${C.supportPhone}`],
              ["Pagina di assistenza", C.supportUrl],
            ],
          },
          "Utilizzando i nostri siti, accettando un preventivo o pagando una fattura, un link di pagamento o un codice QR da noi emessi, accetti i presenti Termini. Se non li accetti, ti preghiamo di non utilizzare i nostri siti o servizi.",
        ],
      },
      {
        id: "services",
        title: "I nostri servizi",
        body: [
          "Eagle Inc offre servizi professionali con i propri marchi, tra cui gestione IT e consulenza IT (cloud, infrastruttura, Microsoft 365/Azure, gestione del portafoglio), servizi digitali e prodotti software, e servizi immobiliari residenziali a Tirana.",
          "I nostri servizi sono immateriali: non è prevista alcuna spedizione fisica. L'ambito esatto, i deliverable, i criteri di accettazione, le tempistiche e il prezzo di ciascun incarico sono indicati nel preventivo scritto, nella proposta, nel contratto o nella fattura che ti emettiamo (l'\"Ordine\"). In caso di contrasto tra un Ordine e i presenti Termini, prevale l'Ordine.",
        ],
      },
      {
        id: "orders",
        title: "Preventivi, ordini e contratto",
        body: [
          {
            list: [
              "Il contratto si conclude quando accetti il nostro preventivo o la nostra proposta scritta (via e-mail, con firma o pagando la relativa fattura o il link di pagamento).",
              "I preventivi sono validi 30 giorni, salvo diversa indicazione.",
              "I servizi e le soluzioni una tantum sono fatturati all'inizio dell'incarico, salvo diversa previsione dell'Ordine.",
              "I servizi continuativi (come IT gestito e gestione del portafoglio) sono forniti con contratto annuale e fatturazione mensile, come stabilito nell'Ordine.",
              "Sei responsabile di fornire informazioni corrette, accesso tempestivo ai sistemi e la collaborazione di cui abbiamo ragionevolmente bisogno per erogare il servizio.",
            ],
          },
        ],
      },
      {
        id: "prices",
        title: "Prezzi e valuta",
        body: [
          "I prezzi sono indicati nell'Ordine e sulla fattura o sul link di pagamento, in lek albanesi (ALL) o euro (EUR). L'importo e la valuta mostrati sulla pagina di pagamento RaiAccept sono l'importo e la valuta che ti verranno addebitati.",
          "Salvo espressa indicazione contraria, i prezzi si intendono IVA esclusa, che viene aggiunta ove previsto dalla normativa fiscale albanese. Se la tua carta è in un'altra valuta, l'emittente può applicare un proprio tasso di cambio e proprie commissioni; Eagle Inc non ha alcun controllo su di essi.",
        ],
      },
      {
        id: "payment",
        title: "Metodi di pagamento e sicurezza dei pagamenti",
        body: [
          "Accettiamo i seguenti metodi di pagamento:",
          {
            list: [
              "carte di credito e di debito Visa e Mastercard;",
              "Apple Pay e Google Pay, se supportati dal tuo dispositivo e dalla tua carta;",
              "link di pagamento e codici QR generati tramite RaiAccept e riportati sulle nostre fatture o inviati via e-mail o messaggio;",
              "bonifico bancario sul conto indicato in fattura.",
            ],
          },
          "I pagamenti con carta, Apple Pay e Google Pay sono elaborati dalla nostra banca acquirer, Raiffeisen Bank Sh.A. (Albania), tramite il suo servizio di e-commerce RaiAccept. I dati della carta vengono inseriti esclusivamente sulla pagina di pagamento sicura della banca, conforme a PCI DSS, tramite una connessione crittografata (TLS). Eagle Inc non vede né conserva mai il numero completo della tua carta, la data di scadenza o il codice di sicurezza. I pagamenti possono richiedere l'autenticazione 3-D Secure da parte dell'emittente della carta.",
          "Un link di pagamento o un codice QR è collegato a una fattura e a un importo specifici. Prima di pagare, verifica sempre che il nome dell'esercente sulla pagina di pagamento sia «Eagle Inc». Se un link è scaduto o non funziona, contatta l'assistenza e te ne invieremo uno nuovo.",
          "Il pagamento è dovuto alla data indicata in fattura. Possiamo sospendere i servizi continuativi se una fattura resta insoluta dopo un sollecito scritto.",
          { note: `Eagle Inc non ti chiederà mai di inviare il numero completo della carta, la data di scadenza o il codice di sicurezza via e-mail, telefono, chat o qualsiasi altro canale. Se ricevi una richiesta del genere a nostro nome, non rispondere e segnalala a ${C.supportEmail}.` },
        ],
      },
      {
        id: "delivery",
        title: "Erogazione dei servizi",
        body: [
          "I servizi sono erogati da remoto e/o in loco, come descritto nell'Ordine. L'erogazione inizia alla data di avvio concordata o dopo la ricezione del pagamento, se è previsto un pagamento anticipato. I deliverable (come report, configurazioni, documentazione o accesso a software) sono consegnati in formato elettronico o in loco. Riceverai una conferma via e-mail quando un servizio pagato è stato erogato o una milestone è stata completata.",
        ],
      },
      {
        id: "cancellation",
        title: "Politica di annullamento e rimborso",
        body: [
          {
            list: [
              "Prima dell'inizio dei lavori: puoi annullare un Ordine per iscritto in qualsiasi momento prima che iniziamo a erogare il servizio e ricevere il rimborso integrale di quanto pagato.",
              "Dopo l'inizio dei lavori: puoi annullare per iscritto; paghi il lavoro svolto e i costi sostenuti fino alla data di annullamento, e l'eventuale importo anticipato per lavoro non ancora svolto ti viene rimborsato.",
              "I contratti annuali con fatturazione mensile possono essere risolti come previsto dal contratto. I mesi già fatturati ed erogati non sono rimborsabili, salvo che il servizio non sia stato fornito.",
              "Addebiti doppi o errati: se ti è stato addebitato due volte o un importo errato, rimborsiamo integralmente l'eccedenza.",
              "Servizi non forniti come concordato: se non eroghiamo un servizio conformemente all'Ordine e non riusciamo a rimediare entro un termine ragionevole, hai diritto a un rimborso totale o proporzionale.",
            ],
          },
          `Come richiedere un rimborso: scrivi a ${C.supportEmail} o usa il modulo su /support, indicando numero di fattura, data di pagamento, importo e motivo. Confermiamo la ricezione entro 1 giorno lavorativo e decidiamo entro 5 giorni lavorativi.`,
          "I rimborsi approvati vengono effettuati sulla stessa carta o sullo stesso metodo di pagamento utilizzato per il pagamento originale (inclusi Apple Pay o Google Pay) — non rimborsiamo i pagamenti con carta in contanti o su un'altra carta. Avviamo il rimborso entro 5 giorni lavorativi dall'approvazione; a seconda dell'emittente della carta, possono essere necessari fino a 10 giorni lavorativi prima che l'importo compaia sul tuo estratto conto.",
          "Se agisci in qualità di consumatore, le norme imperative di tutela dei consumatori del diritto albanese, compreso l'eventuale diritto di recesso previsto dalla legge per i contratti a distanza, si applicano in aggiunta a questa politica e non sono da essa limitate.",
        ],
      },
      {
        id: "disputes",
        title: "Contestazioni di pagamento e chargeback",
        body: [
          `Se non riconosci un addebito di Eagle Inc o non sei d'accordo con un importo, contattaci prima all'indirizzo ${C.supportEmail} — la maggior parte dei casi si risolve rapidamente con un rimborso diretto. Ciò non pregiudica il tuo diritto di contestare una transazione presso l'emittente della carta. In caso di chargeback, collaboreremo con la banca fornendo l'Ordine, la fattura e la documentazione di erogazione pertinenti.`,
        ],
      },
      {
        id: "website-use",
        title: "Utilizzo dei nostri siti web",
        body: [
          "Puoi utilizzare i nostri siti solo per scopi leciti. Non puoi tentare di accedere senza autorizzazione ai nostri sistemi, interferire con il funzionamento dei siti, fornire informazioni false o fare un uso improprio dei nostri moduli. Possiamo modificare, sospendere o interrompere qualsiasi parte dei siti in qualsiasi momento.",
          "Tutti i contenuti dei nostri siti — inclusi testi, loghi, il medaglione Eagle, design, immagini e software — sono di proprietà di Eagle Inc o concessi in licenza a essa e protetti dalle norme sulla proprietà intellettuale. Non puoi copiarli o riutilizzarli senza il nostro previo consenso scritto.",
          "Le informazioni sui nostri siti sono di carattere generale e possono cambiare. Non costituiscono un'offerta se non confermate in un Ordine. I link a siti di terzi sono forniti per comodità; non siamo responsabili del loro contenuto.",
        ],
      },
      {
        id: "liability",
        title: "Responsabilità",
        body: [
          "Eroghiamo i nostri servizi con la dovuta diligenza e secondo le buone pratiche professionali. Nella misura consentita dalla legge, la nostra responsabilità complessiva derivante da un Ordine è limitata all'importo da te pagato in base a tale Ordine nei dodici mesi precedenti l'evento che ha dato origine alla richiesta, e non rispondiamo di danni indiretti o consequenziali, compresi il mancato guadagno o la perdita di dati.",
          "Nulla nei presenti Termini esclude o limita la responsabilità che non può essere esclusa o limitata in base alla legge applicabile, compresa la responsabilità per dolo o colpa grave, né i tuoi diritti inderogabili di consumatore.",
        ],
      },
      {
        id: "privacy",
        title: "Privacy",
        body: ["Trattiamo i dati personali in conformità alla nostra Informativa sulla privacy, disponibile su /privacy."],
      },
      {
        id: "force-majeure",
        title: "Forza maggiore",
        body: ["Nessuna delle parti è responsabile per inadempimenti o ritardi causati da eventi al di fuori del proprio ragionevole controllo, come calamità naturali, interruzioni di corrente o di rete di fornitori terzi, guerre, scioperi o provvedimenti delle autorità. Gli obblighi sono sospesi per la durata di tale evento."],
      },
      {
        id: "law",
        title: "Legge applicabile e controversie",
        body: [
          "I presenti Termini e ogni Ordine sono regolati dalla legge della Repubblica d'Albania. Cerchiamo sempre di risolvere prima i reclami in via amichevole — contatta l'assistenza. Le controversie che non possono essere risolte in via amichevole sono di competenza del tribunale competente di Tirana, Albania, fatto salvo il diritto inderogabile del consumatore di agire dinanzi ai giudici del proprio luogo di residenza.",
        ],
      },
      {
        id: "changes",
        title: "Modifiche ai presenti Termini",
        body: [
          "Possiamo modificare i presenti Termini di tanto in tanto. A ciascun Ordine si applica la versione pubblicata su /termsofuse alla data dell'Ordine. La data dell'ultimo aggiornamento è indicata in cima a questa pagina.",
        ],
      },
    ],
  },

  support: {
    kicker: "ASSISTENZA CLIENTI",
    title: "Assistenza",
    intro: "Aiuto per pagamenti, fatture, rimborsi e i nostri servizi. Il nostro team di assistenza risponde personalmente a ogni richiesta.",
    tocContact: "Contatta l'assistenza clienti",
    tocRequest: "Invia una richiesta di assistenza",
    email: "E-mail",
    phone: "Telefono",
    hoursLabel: "Orari di assistenza",
    hours: "Lunedì – venerdì, 09:00 – 17:00 (CET/CEST, ora di Tirana). Prima risposta entro 1 giorno lavorativo.",
    security: "Per la tua sicurezza, non inviarci mai il numero completo della carta, la data di scadenza o il codice di sicurezza (CVV/CVC). Per identificare un pagamento bastano numero di fattura, data, importo e le ultime quattro cifre della carta.",
    requestTitle: "Invia una richiesta di assistenza",
    faqTitle: "DOMANDE FREQUENTI",
    topics: [
      "Problema di pagamento (rifiutato, non riuscito, link o codice QR scaduto)",
      "Richiesta di rimborso",
      "Addebito doppio o errato",
      "Domanda su una fattura",
      "Domanda su un servizio o un ordine",
      "Privacy / richiesta sui dati personali",
      "Altro",
    ],
    form: {
      name: "Nome e cognome",
      email: "Indirizzo e-mail",
      reference: "Numero di fattura o riferimento (facoltativo)",
      message: "Come possiamo aiutarti? Non indicare mai il numero completo della carta o il codice di sicurezza.",
      consent: "Inviando questo modulo accetti che trattiamo i tuoi dati per gestire la tua richiesta, come descritto in /privacy.",
      send: "INVIA RICHIESTA",
      sending: "INVIO IN CORSO…",
      sentTitle: "Grazie — abbiamo ricevuto la tua richiesta.",
      sentBody: (email) => `Risponderemo entro 1 giorno lavorativo a ${email}.`,
      error: `Non è stato possibile inviare il messaggio. Scrivi a ${C.supportEmail} o chiama il ${C.supportPhone}.`,
    },
    faq: [
      {
        id: "pay-how",
        title: "Come pago una fattura?",
        body: [
          "Ogni fattura contiene un link di pagamento sicuro RaiAccept e un codice QR di Raiffeisen Bank Albania. Clicca sul link o inquadra il codice QR con la fotocamera del telefono, verifica l'importo e che l'esercente sia Eagle Inc, e paga con Visa, Mastercard, Apple Pay o Google Pay. Puoi anche pagare con bonifico bancario sul conto indicato in fattura.",
        ],
      },
      {
        id: "pay-failed",
        title: "Il mio pagamento è stato rifiutato o non è riuscito",
        body: [
          {
            list: [
              "Verifica che i dati della carta, la data di scadenza e i dati di fatturazione siano corretti e che sulla carta siano abilitati i pagamenti online/internazionali.",
              "Completa la verifica 3-D Secure nell'app della tua banca o con il codice SMS — il pagamento non va a buon fine se questo passaggio scade.",
              "Assicurati che la carta abbia saldo o plafond disponibile sufficiente.",
              "Prova con Apple Pay o Google Pay, con un'altra carta, oppure contatta l'emittente della carta — i rifiuti sono decisi dalla banca emittente, che può comunicarti il motivo.",
            ],
          },
          "Un pagamento rifiutato non viene addebitato. Se dopo un tentativo non riuscito sul conto risulta un importo riservato (in sospeso), la tua banca lo sblocca automaticamente, di norma entro pochi giorni lavorativi.",
        ],
      },
      {
        id: "pay-link",
        title: "Il link di pagamento o il codice QR è scaduto o non si apre",
        body: ["I link di pagamento e i codici QR hanno una validità limitata e valgono per un importo specifico. Contattaci indicando il numero di fattura e ti invieremo un nuovo link entro 1 giorno lavorativo."],
      },
      {
        id: "double",
        title: "Mi è stato addebitato due volte o un importo errato",
        body: ["Contattaci indicando il numero di fattura, data e importo di ogni addebito e le ultime quattro cifre della carta. Gli addebiti doppi o errati vengono rimborsati integralmente sulla carta originale."],
      },
      {
        id: "refund",
        title: "Come richiedo un rimborso?",
        body: [
          `Usa il modulo qui sopra o scrivi a ${C.supportEmail} indicando numero di fattura, data di pagamento, importo e motivo della richiesta. Confermiamo la ricezione entro 1 giorno lavorativo e decidiamo entro 5 giorni lavorativi. I rimborsi approvati vengono effettuati sulla stessa carta o wallet utilizzati per il pagamento e avviati entro 5 giorni lavorativi; l'emittente della carta può impiegare fino a 10 giorni lavorativi per mostrare l'importo sull'estratto conto. La politica completa è nei nostri Termini d'uso: /termsofuse.`,
        ],
      },
      {
        id: "receipt",
        title: "Dove trovo la ricevuta o la fattura?",
        body: ["Dopo un pagamento riuscito ricevi una conferma di pagamento dalla pagina di pagamento. Inviamo la fattura e, su richiesta, una conferma di avvenuto pagamento all'indirizzo e-mail che abbiamo in archivio. Chiedi all'assistenza se ti serve una copia."],
      },
      {
        id: "complaint",
        title: "Reclami ed escalation",
        body: [
          `Se non sei soddisfatto della gestione della tua richiesta, rispondi al nostro messaggio chiedendo un'escalation — il tuo reclamo sarà esaminato dalla direzione di ${C.legalName} e riceverà risposta entro 10 giorni lavorativi. Conservi sempre il diritto di rivolgerti all'emittente della carta o alle autorità competenti.`,
        ],
      },
    ],
  },
});
